"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorLevel;
(function (ErrorLevel) {
    ErrorLevel["NONE"] = "NONE";
    ErrorLevel["WARN"] = "WARN";
    ErrorLevel["ERROR"] = "ERROR";
    ErrorLevel["THROW"] = "THROW";
})(ErrorLevel = exports.ErrorLevel || (exports.ErrorLevel = {}));
//# sourceMappingURL=types.js.map